import { ThemeProvider } from "@fluentui/react";
import React, { useContext, useEffect } from "react";
import { BrowserRouter, RouterProvider, useNavigate } from "react-router-dom";
import "./App.css";
import { RouterConfig } from "./config/RouterConfig";
import { darkTheme, lightTheme } from "./constants/Themes";
import Navbar from "./components/navbar/Navbar";
import themeContext from "./context/theme/ThemeContext";
import StudyviewerState from "./context/studyviewer/StudyViewerState";
import ThumbnailState from "./context/studyviewer/ThumbnailState";
import ViewportState from "./context/studyviewer/ViewportState";
import StudyReportState from "./context/studyreport/StudyReportState";
import AnnotationState from "./context/annotation/AnnotationState";
import ReportPanel from "./pages/Report/ReportPanel";
import ToastState from "./context/toast/ToastState";
import toastContext from "./context/toast/ToastContext";
import Toast from "./components/Toast_v2/Toast";
import loaderContext from "./context/loader/LoaderContext";
import TopLoader from "./components/TopLoadingBar/TopLoader";
import userContext from "./context/users/UserContext";
import {
  BrowserView,
  MobileView,
  isBrowser,
  isMobile,
} from "react-device-detect";
import { IconButton, registerIcons } from '@fluentui/react';
import SortMobileIcon from "./components/SVGComponents/SortMobileIcon";
import MobileBottomBar from "./components/navbar/MobileBottomBar";
import MobileNavbar from "./components/navbar/MobileNavbar";
import ShareStudyState from "./context/sharestudy/ShareStudyState";
import Viewer from "./pages/StudyViewer/Viewer";
import Router from "./Router";
import UserState from "./context/users/UserState";
import ThemeState from "./context/theme/ThemeState";
import LoaderState from './context/loader/LaoderState';
import { I18nextProvider } from "react-i18next";
import i18n from "./config/i18n";
import { AuthRoutes } from "./constants/Constants";


function App() {
  // OLD (VAPT): read the flags from localStorage on every page load. They are no longer stored
  // in the browser; Router.jsx now redirects right after loadByUsername, using the server's answer.
  // useEffect(() => {
  //   const isForceReset = localStorage.getItem("forceReset") === "true" || localStorage.getItem("redirectOnLogin") === "true" ? true : false;
  //   if (isForceReset && window.location.pathname !== AuthRoutes.FORCECHANGEPWD) {
  //     window.open(AuthRoutes.FORCECHANGEPWD, "_self");
  //   }
  // }, [])


  useEffect(() => {
    window.addEventListener("popstate", function (event) {
        // Don't reload when the mobile filter popup is open (e.g. iOS back-swipe gesture)
        if (document.querySelector('.popup.open')) {
          return;
        }
        window.location.reload();
    });
  }, [])

  return (
    <I18nextProvider i18n={i18n}>
      <UserState>
        <ThemeState>
          <ToastState>
            <LoaderState>
              <Router />
            </LoaderState>
          </ToastState>
        </ThemeState>
      </UserState>
    </I18nextProvider>
  );
}

export default App;
